var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        staticClass: "flex-wrap items-center justify-center flex",
        staticStyle: {
          "background-color": "white",
          "border-left": "5px lightgrey solid",
          transition: "0.5s",
        },
      },
      [
        _c("h3", { staticClass: "hidden-lg hidden-md hidden-xl" }, [
          _vm._v("Verify " + _vm._s(_vm._f("sentenceCase")(_vm.$starLabel))),
        ]),
        _vm._v(" "),
        _c(
          "video",
          {
            staticStyle: { margin: "2rem" },
            attrs: { width: "180", height: "180", controls: "" },
          },
          [
            _c("source", {
              attrs: { src: _vm.user.profile.onboarding_video_link },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "h3",
          { staticClass: "hidden-sm hidden-xs", staticStyle: { flex: "1" } },
          [_vm._v("Verify " + _vm._s(_vm._f("sentenceCase")(_vm.$starLabel)))]
        ),
        _vm._v(" "),
        _vm.user.status === "active"
          ? _c(
              "div",
              {
                staticClass:
                  "margin-r-2 flex items-center justify-center flex-wrap",
              },
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-primary margin-x-1",
                    staticStyle: {
                      border: "solid 2px #F77211",
                      "min-width": "180px",
                    },
                    attrs: { click: _vm.handleActivateUserCallback },
                  },
                  [
                    _vm._v(
                      "Activate " +
                        _vm._s(_vm._f("sentenceCase")(_vm.$starLabel))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ladda-button",
                  {
                    staticClass:
                      "btn btn-primary-outline-simple margin-x-1 margin-y-1",
                    staticStyle: { "min-width": "180px" },
                    attrs: { click: _vm.handleDeleteVideoCallback },
                  },
                  [_vm._v("Delete Video")]
                ),
              ],
              1
            )
          : _c("div", { staticClass: "spacer-x-3" }, [
              _c("h3", [
                _c("i", { staticClass: "fa fa-check" }),
                _vm._v(" User notified"),
              ]),
            ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }